export default __webpack_public_path__ + "static/media/bg-about9.5c0f6d60.jpg";